export default "__VITE_ASSET__DQh4Y8of__"